import React from "react"
import { NavLink } from "react-router-dom"
import Logo from "./Logo"

const Header = () => {
  return (
    <header className="flex items-center justify-between py-2 px-4 absolute w-full">
      <Logo />

      <nav>
        <ul className="flex">
          <li>
            <NavLink
              to="/"
              exact
              className="text-white hover:bg-gray-200 hover:text-gray-900 py-2 px-3 rounded-lg mx-1"
              activeClassName="bg-gray-200 text-gray-900"
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              className="text-white hover:bg-gray-200 hover:text-gray-900 py-2 px-3 rounded-lg mx-1"
              activeClassName="bg-gray-200 text-gray-900"
              to="/services"
            >
              Services
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to="/get-started"
              className="text-white hover:bg-gray-200 hover:text-gray-900 py-2 px-3 rounded-lg mx-1"
              activeClassName="bg-gray-200 text-gray-900"
            >
              Get Started
            </NavLink>
          </li> */}
        </ul>
      </nav>
    </header>
  )
}

export default Header
